import { get } from 'lodash';

export const getUser = (state) => get(state, 'login.user');

export const getCustomerId = (state) => get(getUser(state), 'customer_id');

export const selectLoginFirstName = (state) => get(getUser(state), 'first_name');

export const selectLastFirstName = (state) => get(getUser(state), 'last_name');

export const selectDomain = (state) => get(getUser(state), 'domain');

export const selectCustomerUrl = (state) => get(getUser(state), 'customer_url');

export const selectIsAuthenticated = (state) => get(state, 'login.isAuthenticated', false);

export const selectUserPermissions = (state) => get(state, 'login.user.currentPermissions', []);

export const selectUserToken = (state) => get(state, 'login.token', []);
